import { page, getById } from '@/api/base/basePort'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(page, getById)
